import styled, { css } from "styled-components";
import theme from 'common/theme'

export const buttonStyles = css`
  font-family: inherit;
  border-radius: 25px;
  border-style: solid;
  border-width: 1px;
  color: white;
  cursor: pointer;
  padding: 0.5em 2em;
  font-weight: 500;

  background-color: ${theme.colors.jbtBlue};
  border-color: ${theme.colors.jbtBlue};

  &.is-disabled {
    cursor: not-allowed;
    
    bacground-color: ${theme.colors.gray200};
    color: ${theme.colors.gray800};
    border-color: ${theme.colors.gray200};
  }


   
`

export const ButtonPrimary = styled.button.attrs(({ type }: { type?: string }) => ({ type: type || 'button' }))`
    
    ${buttonStyles}
  
`
export const ButtonOutlined = styled.button.attrs(({ type }: { type?: string }) => ({ type: type || 'button' }))`
  
  ${buttonStyles}

  background-color: transparent;
  color: ${theme.colors.jbtBlue};

` 
export const ButtonCancel = ButtonOutlined
export const ButtonSubmit = styled.input.attrs(({ value }: { value?: string })=> ({ type: 'submit', value: value || 'Submit' }))`
  ${buttonStyles}
`